import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import axiosOrganizationInstance from "./AxiosOrganizationInstance";

import "./css/create-school.css"; // Ensure this path is correct

const Createorganization = () => {
  let userId = localStorage.getItem("userId");
  userId = JSON.parse(userId);  
  // alert("userId "+ user.userId)

  const [organizationCode, setorganizationCode] = useState("");
  const [organizationName, setorganizationName] = useState("");
  const [organizationType, setorganizationType] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [notes, setNotes] = useState("");
  const [status] = useState("INACTIVE"); // Default to INACTIVE and hide
  const [website, setWebsite] = useState("");
  const [isAdmissions, setIsAdmissions] = useState(false);
  const [specializations, setSpecializations] = useState("");
  const [features, setFeatures] = useState("");
  const [offers, setOffers] = useState("");
  const [createdById,setCreatedById] = useState("");
  const [organizationPhoto, setorganizationPhoto] = useState(null); // For the organization photo

  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [lat, setlat] = useState(0);
  const [lon, setlon] = useState(0);
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const [addressSearch, setAddressSearch] = useState('')
  const navigate = useNavigate();

  // Handle Address Search
  const handleAddressSearch = async (e) => {
    setAddressSearch(e.target.value);
    if (e.target.value.length > 2) {
      try {
        const response = await axiosOrganizationInstance.get(`/get-address`, {
          params: {
            address: e.target.value,
          },
        });
        setAddressSuggestions(response.data.suggestions || []);
      } catch (error) {
        console.error(
          "Error fetching address suggestions:",
          error.response ? error.response.data : error.message
        );
      }
    } else {
      setAddressSuggestions([]);
    }
  };

  // Handle Address Selection
  const handleAddressSelect = async (placeId) => {
    try {
      const response = await axiosOrganizationInstance.get(`/get-address-details`, {
        params: { placeId },
      });

      const placeDetails = response.data;
      console.log('Data', placeDetails)
      if (!placeDetails) {
        alert("Address details not found");
        return;
      }
      const fullAddress = `${placeDetails.addressLine1 || ""}, ${placeDetails.addressLine2 || ""}, ${placeDetails.city || ""}, ${placeDetails.state || ""}, ${placeDetails.country || ""}, ${placeDetails.postalCode || ""}`;
      console.log('ADD', fullAddress)
      setAddressSearch(fullAddress)
      setAddressSearch(fullAddress)
      setAddressLine1(placeDetails.addressLine1);
      setAddressLine2(placeDetails.addressLine2 || "");
      setPostalCode(placeDetails.postalCode || "");
      setCity(placeDetails.city || "");
      setState(placeDetails.state || "");
      setCountry(placeDetails.country || "");
      setlat(placeDetails.lat || 0);
      setlon(placeDetails.lon || 0);
      setAddressSuggestions([]); // Clear suggestions after selection
     
    
      
    } catch (error) {
      console.error(
        "Error fetching place details:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const handleorganizationPhotoChange = (e) => {
    setorganizationPhoto(e.target.files[0]);
  };

  const handleAdmissionChange = (event) => {
    setIsAdmissions(event.target.checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create the data object
    const data = {
      organizationCode,
      organizationName,
      organizationType,
      phoneNumber,
      email,
      website,
      notes,
      status,
      isAdmissions,
      specializations,
      features,
      offers,
      createdById: userId,
      address: {
        addressLine1,
        addressLine2,
        city,
        state,
        country,
        postalCode,
        lat,
        lon,
      },
    };

    // Create FormData
    const organizationData = new FormData();
    organizationData.append("data", JSON.stringify(data)); // Append the data object as JSON string

    // If a organization photo is provided, append it
    if (organizationPhoto) {
      organizationData.append("photo", organizationPhoto); // Make sure to use 'photo' to match the backend
    }

    try {
      const token = localStorage.getItem("Token");
      const response = await axiosOrganizationInstance.post("/organization-address",
        organizationData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Important for file uploads
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // alert('organization added successfully');

        // Update the organizationId in localStorage
        localStorage.setItem("organizationId", response.data.organizationId);

        // Redirect to organization dashboard
        navigate("/organization/dashboard");

        // Reset form fields after successful submission
        setorganizationCode("");
        setorganizationName("");
        setorganizationType("");
        setphoneNumber("");
        setEmail("");
        setNotes("");
        setWebsite("");
        setIsAdmissions(false);
        setCreatedById(userId);
        setorganizationPhoto(null);
        setAddressLine1("");
        setAddressLine2("");
        setCity("");
        setState("");
        setCountry("");
        setPostalCode("");
        setlon(0);
        setlat(0);
      } else {
        alert("Failed to add organization");
      }
    } catch (error) {
      console.error(
        "Error adding organization:",
        //error.response ? error.response.data.error : error.message.data
        JSON.stringify(error.response)
      );
      alert(
        //"An error occurred while adding the organization. Check the console for details."
        JSON.stringify(error.response.data.error)
      );
    }
  };

  return (
    <div className="create-organization-container">
      <h4>Create Organization</h4>
      <hr />
      <form onSubmit={handleSubmit} className="create-organization-form needs-validation was-validated" noValidate>
        {/* Row 1 start */}
       
        
        <div className="row">

          <div className="col-md-4">
            <label htmlFor="organizationname" className="form-label">
              Name <span className="text-danger" >*</span>
            </label>
            <input
              type="text"
              value={organizationName}
              className="form-control"
              id="organizationname"
              onChange={(e) => setorganizationName(e.target.value)}
              required
              // placeholder="Enter organization name"
            />
          </div>
          <div className="col-md-4">
            <label htmlFor="organizationshortcode" className="form-label">
              Registration Number <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="organizationshortcode"
              value={organizationCode}
              onChange={(e) => setorganizationCode(e.target.value)}
              required
              // placeholder="Enter organization short code"
        
            />
          </div>
          
          <div className="col-md-4">
            <label htmlFor="organizationtype" className="form-label">
              Type <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              value={organizationType}
              className="form-control"
              id="organizationtype"
              onChange={(e) => setorganizationType(e.target.value)}
              required
              // placeholder="Enter organization type"              
            />
          </div>
          
        </div>
           {/* Row 1 end */}

           {/* Row 2 start */}
        
        <div className="row">

          <div className="col-md-4">
            <label className="form-label" htmlFor="phoneNumber">
              Phone Number <span className="text-danger" >*</span>
            </label>
            <input
              type="text"
              value={phoneNumber}
              id="phoneNumber"
              className="form-control"
              onChange={(e) => setphoneNumber(e.target.value)}
              required
              // placeholder="Enter contact number"
              
            />
          </div>
          <div className="col-md-4">
          <label className="form-label" htmlFor="organizationemail">Email <span className="text-danger" >*</span></label>
          <input
            type="email"
            value={email}
            id='organizationemail'
            className="form-control"
            onChange={(e) => setEmail(e.target.value)}
            required
            // placeholder="Enter email"
            
          />
        </div>

        <div className="col-md-4">
          <label className="form-label" htmlFor="organizationwebsite">Website</label>
          <input
            type="text"
            value={website}
            id='organizationwebsite'
            className="form-control"
            onChange={(e) => setWebsite(e.target.value)}
            // placeholder="Enter website URL"
          />
        </div>
        
       </div>
           {/* Row 2 end */}

       
        <div className="row" id="row3">
       
          <div className="col-md-6">
          <label className="form-label" htmlFor="notes">Notes</label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            // placeholder="Enter any notes"
            id="notes"
            className="form-control"
          />
          </div>
          <div className="col-md-4">
            <label className="form-label" htmlFor="photo">Photo</label>
            <input
              type="file"
              onChange={handleorganizationPhotoChange}
              className="upload-photo-input form-control"
              id='photo'
            />
          </div>
          <div className="col-md-2">
            <label className="form-label" htmlFor="isAdmissions">Is Admissions Open</label><br/>
            <input
              type="checkbox"
              checked={isAdmissions}
              onChange={handleAdmissionChange}
              id="isAdmissions"
              className="w-20px h-20px"
            />
          </div>
        
        </div>
        
        <div className="row" id="row4">
       
          <div className="col-md-6">
          <label className="form-label" htmlFor="notes">Specializations</label>
          <textarea
            value={specializations}
            onChange={(e) => setSpecializations(e.target.value)}
            // placeholder="Enter any notes"
            id="notes"
            className="form-control"
          />
          </div>
          <div className="col-md-6">
          <label className="form-label" htmlFor="notes">Features</label>
          <textarea
            value={features}
            onChange={(e) => setFeatures(e.target.value)}
            // placeholder="Enter any notes"
            id="notes"
            className="form-control"
          />
          </div>
          <div className="col-md-6">
          <label className="form-label" htmlFor="notes">Offers</label>
          <textarea
            value={offers}
            onChange={(e) => setOffers(e.target.value)}
            // placeholder="Enter any notes"
            id="notes"
            className="form-control"
          />
          </div>
        
        </div>
       

        {/* Address Section with Autocomplete */}
        <hr />
        <h4>Address</h4>
        {/* address row 1 start */}
        <div className="row">
            <div className="col-md-12">
                <label id='search' className="form-label">Search Address</label>
                <input
                type='text'
                value={addressSearch}
                onChange={handleAddressSearch}
                onFocus={()=>setAddressSearch('')}
                className="form-control"
                id='search'
                />
                {addressSuggestions.length > 0 && (
              <ul className="address-suggestions">
                {addressSuggestions.map((suggestion) => (
                  <li
                    key={suggestion.place_id}
                    onClick={() => handleAddressSelect(suggestion.place_id)}
                  >
                    {suggestion.description}
                  </li>
                ))}
              </ul>
            )}
            </div>
        </div>
          {/* address row 1 end */}
        <div className="row">
          <div className="col-md-6">
            <label className="form-label" htmlFor="addressline1">Address Line 1 <span className="text-danger" >*</span></label>
            <input
              type="text"
              value={addressLine1}
              id='addressline1'
              onChange={(e)=>setAddressLine1(e.target.value)}
              className="form-control"
              required
            //   placeholder="Enter address line 1"
            />
            
          </div>
          <div className="col-md-6">
            <label className="form-label" htmlFor="addressline2">Address Line 2</label>
            <input
              type="text"
              value={addressLine2}
              id='addressline2'
              className="form-control"
              onChange={(e) => setAddressLine2(e.target.value)}
            //   placeholder="Enter address line 2"
            />
          </div>
          
        </div>

        <div className="row">
          <div className="col-md-4">
            <label className="form-label" htmlFor="city">City <span className="text-danger" >*</span></label>
            <input
              type="text"
              value={city}
              id='city'
              className="form-control"
              onChange={(e) => setCity(e.target.value)}
              required
            //   placeholder="Enter city"
              
            />
          </div>
          <div className="col-md-4">
            <label className="form-label" htmlFor="state">State <span className="text-danger" >*</span></label>
            <input
              type="text"
              value={state}
              id="state"
              className="form-control"
              onChange={(e) => setState(e.target.value)}
              required
            //   placeholder="Enter state"
              
            />
            
          </div>
          <div className="col-md-4">
            <label className="form-label" id='postalcode'>Postal Code <span className="text-danger" >*</span></label>
            <input
              type="text"
              value={postalCode}
              id='postalcode'
              className="form-control"
              onChange={(e) => setPostalCode(e.target.value)}
              required
            //   placeholder="Enter postal code"
              
            />
          </div>
        </div>

        {/* Hidden fields for country, lat, lon */}
        <input type="hidden" value={country} />
        <input type="hidden" value={lon} />
        <input type="hidden" value={lat} />

        <button type="submit">Create organization</button>
      </form>
    </div>
  );
};

export default Createorganization;
